// What a guest can tell the venue their party needs of its table (samwise booking/needs.go). Only these are offered
// online (samwise /guest/table_needs answers which of them the venue has tables for); a code Collins doesn't know
// yet is left out, since it has no label.

export interface TableNeed {
  code: string;
  // Swedish source texts, translated by TranslateService.getString: what the guest ticks, and the need in short
  label: string;
  short: string;
  icon: string;
}

export const TABLE_NEEDS: readonly TableNeed[] = [
  { code: 'wheelchair', label: 'Någon sitter i rullstol', short: 'Rullstol', icon: 'fa-wheelchair' },
  { code: 'dog', label: 'Vi har med hund', short: 'Hund', icon: 'fa-dog' },
  { code: 'highchair', label: 'Vi behöver barnstol', short: 'Barnstol', icon: 'fa-baby' },
  { code: 'stroller', label: 'Vi har barnvagn', short: 'Barnvagn', icon: 'fa-baby-carriage' },
  { code: 'outdoor', label: 'Vi vill sitta ute', short: 'Sitta ute', icon: 'fa-sun' },
];

// The needs Collins can show of the codes, in the catalogue's order
export function tableNeeds(codes: readonly string[] | undefined): TableNeed[] {
  return TABLE_NEEDS.filter(need => (codes ?? []).includes(need.code));
}

// The picked codes with `code` ticked or not, in the catalogue's order
export function toggleNeed(picked: readonly string[], code: string): string[] {
  const next = picked.includes(code) ? picked.filter(c => c !== code) : [...picked, code];
  return tableNeeds(next).map(need => need.code);
}
